import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from "react";
import { cn } from "@/lib/utils";

// Radix Checkbox wrapper. Brand-red fill on checked, 18×18 box with a
// 44×44 minimum hit area via padding so gloves-friendly. Pair with a
// `<label>` for clickable text — Radix forwards label-click semantics.
export const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(function Checkbox({ className, ...props }, ref) {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        "inline-flex h-[18px] w-[18px] flex-none items-center justify-center",
        "rounded border border-zinc-400 bg-brand-white text-brand-white",
        "data-[state=checked]:border-brand-red data-[state=checked]:bg-brand-red",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator data-testid="checkbox-indicator">
        <svg
          viewBox="0 0 20 20"
          fill="none"
          className="h-3 w-3"
          aria-hidden="true"
        >
          <path
            d="M4 10l4 4 8-9"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
